<nav
	class="cv-left-nav"
	[@collapse]="{value: toggleState, params: {width: width}}"
	[ngClass]="{ 'is-collapsed': isCollapsed() }"
	[ngStyle]="{'background-color': (uiConfigStyle?.backgroundColor)}"
>
	<div class="container">

		<ul *ngFor="let nav of navItems; let index = index" class="nav flex-column" [class]="nav.customClass" [ngClass]="{'add-bottom-border': !isCollapsed()}">
			<ng-container *ngTemplateOutlet="rootMenuTemplate; context: {$implicit:nav, deepLevel: 0, index:index}"></ng-container>
		</ul>

		<ng-template #rootMenuTemplate let-nav let-deepLevel="deepLevel" let-index let-firstChild="firstChild" let-lastChild="lastChild" >
			<!-- No items and not part of a Section -->
			<ng-container *ngIf="!nav.items && !nav.section">
				<li class="nav-item">
					<div *ngIf="deepLevel > 0 && !nav.hideDivider" [ngClass]="{'child-level ': deepLevel > 1}" class="sub-item-line"></div>
					<ng-container *ngTemplateOutlet="simpleItemTemplate; context:{$implicit: nav, index:index, deepLevel: deepLevel, numChild: 0}"></ng-container>
				</li>
			</ng-container>
			<!-- More items and not part of a Section -->
			<ng-container *ngIf="nav.items && !nav.section">
				<ng-container *ngTemplateOutlet="multipleItemsTemplate; context:{$implicit: nav, deepLevel: deepLevel, firstChild: firstChild, lastChild: lastChild}"></ng-container>
			</ng-container>

			<!-- A Section Element -->
			<ng-container *ngIf="nav.section">
				<li class="nav-item-title">
					<a class="section-title">
					  <span>
						{{ nav.section }}
					  </span>
					</a>
					<ul *ngFor="let innerNav of nav.items; let innerIndex = index" class="nav flex-column" [class]="innerNav.customClass">
						<ng-container *ngTemplateOutlet="rootMenuTemplate; context: {$implicit: innerNav}"></ng-container>
					</ul>
				</li>
			</ng-container>
		</ng-template>

		<!-- Templates -->
		<!-- Single item template -->
		<ng-template #simpleItemTemplate let-nav let-index let-deepLevel="deepLevel" let-firstChild="firstChild" let-lastChild="lastChild" let-numChild="numChild">
			<a class="nav-link"
			   [ngStyle]="{'color': (uiConfigStyle?.item?.textColor)}"
			   (click)="onRouteClick(nav)"
			   [routerLink]="canNavigate(nav) ? nav.route : null"
			   [ngClass]="{'child-level': ((deepLevel >= 1 && numChild > 0) || deepLevel > 1)}"
			   [class.active]="onRouterLinkActive(nav) || nav.active">
				<i *ngIf="useNewTooltip" [ngClass]="getIconClass(nav)" class="nav-icon" cvNewTooltip [tooltipText]="nav.label" [tooltipPlacement]="tooltipPlacement"></i>
				<i *ngIf="!useNewTooltip" [ngClass]="getIconClass(nav)" class="nav-icon" cvTooltip [tooltipText]="nav.label" [tooltipPlacement]="tooltipPlacement"></i>
				<span class="item-label">{{((!nav['label']) ? 'Not Defined' : nav['label'])}}</span>
				<!-- Collapsable toggle -->
				<i *ngIf="nav.items && nav.items.length" class="toggle-up fas fa-angle-up"
				   [@collapse]="getCollapsedIconState(index)" (click)="onToggleCollapse(index, $event)"></i>
				<div *ngIf="nav.badge" class="badge badge-pill" [ngClass]="{'badge-counter': nav.items && nav.items.length && nav.badgeCounter}">
					{{ nav.badge }}
					<i *ngIf="nav.badgeIcon" class="fa" [ngClass]="nav.badgeIcon"></i>
				</div>
			</a>
		</ng-template>

		<!-- Multiple items -->
		<ng-template #multipleItemsTemplate let-nav let-index let-deepLevel="deepLevel" let-firstChild="firstChild" let-lastChild="lastChild">
			<li class="nav-item" [ngClass]="{'multilevel': (deepLevel >= 2)}">
				<ng-container *ngTemplateOutlet="simpleItemTemplate; context:{$implicit: nav, deepLevel: deepLevel, firstChild: firstChild, lastChild: lastChild, numChild: nav.items.length}"></ng-container>
				<ul *ngFor="let innerNav of nav.items; let i = index; let first = first; let last = last;" class="nav flex-column" [class]="innerNav.customClass">
					<div class="menu-items-container" [@collapse-up]="{value: collapsedStates.get(index)}">
						<ng-container *ngTemplateOutlet="rootMenuTemplate; context: {$implicit: innerNav, deepLevel: 1 + deepLevel, firstChild: first, lastChild: last}"></ng-container>
					</div>
				</ul>
			</li>
		</ng-template>
	</div>

	<div class="menu-toggle"
		 [ngStyle]="{'background-color': (uiConfigStyle?.menuToggle?.backgroundColor)}"
		 (click)="onToggle()">
		<a class="link">
			<i [@collapse]="getToggleIconState()" class="icon fas fa-angle-left"></i>
		</a>
	</div>

</nav>
